import energy_2 from './energy.png';
import communication_2 from './communication.png';
import illumination_2 from './illumination.png';
import traffic_2 from './traffic.png';
import transportation_2 from './transportation.png';
import parking_2 from './parking.png';
import solid_waste_2 from './solid_waste.png';
import water_2 from './water.png';
import default_2 from './default.png';
import emergency_2 from './emergency.png';
import environment from './environment.png';

export {
    default_2,
    energy_2,
    parking_2,
    solid_waste_2,
    water_2,
    communication_2,
    illumination_2,
    traffic_2,
    transportation_2,
    emergency_2,
    environment
};